// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_FVg","cls2":"Header-cls2_KxK Header-cls1_FVg"};